/* DefaultFailCommsSectionMgrRenderer.js */

'use strict';

class DefaultFailCommsSectionMgrRenderer{
    constructor(model, logger){
        this._model = model;
        this.log = logger;
        this._rootElem = document.createElement('failcomms-section-content-gl');
        this.rootElement.component = this.model;
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    get rootElement(){
        return this.getRootElement();
    }

    get model(){
        return this.getModel();
    }

    _shutdown() {
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                this._rootElem.remove();
                this._rootElem = undefined;
                this._model = undefined;
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    _registerListeners(){
        this._model.on("Shutdown",this._onShutdown = this._onShutdown.bind(this));
        this._model.on("refreshAttempts",this._refreshAttempts = this._refreshAttempts.bind(this));
    }

    _unregisterListeners(){
        this._model.removeListener("Shutdown",this._onShutdown);
        this._model.removeListener("refreshAttempts",this._refreshAttempts);
    }

    render(){
        this._rootElem.innerHTML = `
            <section class="form-container">
                <div class="logo-container">
                    <div class="logo"></div>
                </div>
                <section class="message-content">
                    <img src="data:image/svg+xml;base64,DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0zNiwxMC4zYzEuMywwLDIuNiwwLjEsMy44LDAuM0w0MC40LDRjMC0yLjItMS44LTQtNC00aC0wLjNjLTIuMiwwLTQsMS44LTQsNGwwLjUsNi41DQoJCQlDMzMuOCwxMC40LDM0LjksMTAuMywzNiwxMC4zeiIvPg0KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNTIuMSwxNS45bDMuOC01LjVDNTcsOC41LDU2LjQsNiw1NC41LDQuOWwtMC4yLTAuMWMtMS45LTEuMS00LjQtMC41LTUuNSwxLjVsLTIuOCw2DQoJCQlDNDguMiwxMy4yLDUwLjIsMTQuNCw1Mi4xLDE1Ljl6Ii8+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik02Ny43LDE4LjJMNjcuNiwxOGMtMS4xLTEuOS0zLjUtMi42LTUuNS0xLjVsLTUuNiwzLjljMS40LDEuOSwyLjYsNCwzLjUsNi4ybDYuMi0yLjkNCgkJCUM2OC4xLDIyLjYsNjguOCwyMC4yLDY3LjcsMTguMnoiLz4NCgkJPGc+DQoJCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMzYuMiwxNS42TDM2LjIsMTUuNmMzLjQsMCw2LjEsMi43LDYuMSw2LjF2Mi45YzAsMC4zLDAsMC41LDAsMC44bC0xLjksMTQuOGMtMC4zLDIuMS0yLjEsMy44LTQuMywzLjhoMA0KCQkJCWMtMi4yLDAtNC0xLjYtNC4zLTMuOGwtMS44LTE0LjhjMC0wLjIsMC0wLjUsMC0wLjd2LTIuOUMzMC4xLDE4LjMsMzIuOSwxNS42LDM2LjIsMTUuNnogTTM1LjYsNDYuOGgxLjNjMi44LDAsNS4xLDIuMyw1LjEsNS4xdjANCgkJCQljMCwyLjgtMi4zLDUuMS01LjEsNS4xaC0xLjNjLTIuOCwwLTUuMS0yLjMtNS4xLTUuMXYwQzMwLjUsNDkuMSwzMi44LDQ2LjgsMzUuNiw0Ni44eiIvPg0KCQk8L2c+DQoJPC9nPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik02OC41LDMyLjFsLTYuOCwwLjZjMC4yLDEuMSwwLjMsMi4zLDAuMywzLjVjMCwxLjItMC4xLDIuNC0wLjMsMy42bDYuOSwwLjZjMi4yLDAsNC0xLjgsNC00bDAtMC4zDQoJCUM3Mi41LDMzLjksNzAuNywzMi4xLDY4LjUsMzIuMXoiLz4NCgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNjYuMiw0OC44TDYwLDQ1LjljLTAuOSwyLjItMi4xLDQuMy0zLjYsNi4ybDUuNiwzLjljMS45LDEuMSw0LjQsMC41LDUuNS0xLjVsMC4xLTAuMg0KCQlDNjguOCw1Mi4zLDY4LjEsNDkuOSw2Ni4yLDQ4Ljh6Ii8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTUyLDU2LjVjLTEuOSwxLjUtMy45LDIuNy02LjIsMy42bDIuOSw2LjFjMS4xLDEuOSwzLjUsMi42LDUuNSwxLjVsMC4yLTAuMWMxLjktMS4xLDIuNi0zLjUsMS41LTUuNQ0KCQlMNTIsNTYuNXoiLz4NCgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMzYsNjIuMWMtMS4xLDAtMi4zLTAuMS0zLjQtMC4ybC0wLjYsNi43YzAsMi4yLDEuOCw0LDQsNGgwLjNjMi4yLDAsNC0xLjgsNC00bC0wLjYtNi43DQoJCUMzOC42LDYxLjksMzcuMyw2Mi4xLDM2LDYyLjF6Ii8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTIwLjMsNTYuN2wtMy44LDUuNGMtMS4xLDEuOS0wLjQsNC40LDEuNSw1LjVsMC4yLDAuMWMxLjksMS4xLDQuNCwwLjUsNS41LTEuNWwyLjgtNg0KCQlDMjQuMyw1OS4zLDIyLjIsNTguMSwyMC4zLDU2Ljd6Ii8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTEyLjEsNDZsLTUuOCwyLjhjLTEuOSwxLjEtMi42LDMuNS0xLjUsNS41bDAuMSwwLjJjMS4xLDEuOSwzLjUsMi42LDUuNSwxLjVsNS40LTMuNw0KCQlDMTQuMyw1MC4zLDEzLDQ4LjMsMTIuMSw0NnoiLz4NCgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTAuMSwzNi4yYzAtMS4yLDAuMS0yLjQsMC4zLTMuNUw0LDMyLjFjLTIuMiwwLTQsMS44LTQsNHYwLjNjMCwyLjIsMS44LDQsNCw0bDYuNC0wLjUNCgkJQzEwLjMsMzguNiwxMC4xLDM3LjQsMTAuMSwzNi4yeiIvPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0xNS43LDIwLjJsLTUuMy0zLjdDOC41LDE1LjQsNiwxNi4xLDQuOSwxOGwtMC4xLDAuMmMtMS4xLDEuOS0wLjQsNC40LDEuNSw1LjVsNS44LDIuNw0KCQlDMTMsMjQuMiwxNC4yLDIyLjEsMTUuNywyMC4yeiIvPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yMC4yLDE1LjdjMS45LTEuNSw0LTIuNyw2LjItMy42bC0yLjgtNS45Yy0xLjEtMS45LTMuNS0yLjYtNS41LTEuNUwxOCw0LjljLTEuOSwxLjEtMi42LDMuNS0xLjUsNS41DQoJCUwyMC4yLDE1Ljd6Ii8+DQo8L2c+DQo8L3N2Zz4=">
                    <div class="content">
                        <h2 class="message-title">Server Communications Interrupted</h2>
                        <p class="message-text">The connection to the Gluware server has been interrupted. Please wait while we attempt to reconnect...</p>
                        <p class="message-attempts">Connection attempt #1</p>
                    </div>
                </section>
            </section>
        `;

        return Promise.resolve();
    }

    getRootElement(){
        return this._rootElem;
    }

    getModel(){
        return this._model;
    }
    
    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown(){
        this._shutdown();
    }

    _refreshAttempts(){
        let connectionAttemptNumber = this._model.getConnectionAttempts();
        let messageAttemptsElement = this._rootElem.querySelector('.message-attempts');

        if (connectionAttemptNumber && messageAttemptsElement) {
            messageAttemptsElement.innerHTML = "Connection attempt #" + connectionAttemptNumber;
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = DefaultFailCommsSectionMgrRenderer;